export type AppError = Error & { status?: number };

export function createError(
  errorMessage: string,
  title?: string,
  status?: number
): AppError {
  const error = new Error(errorMessage) as AppError;
  if (title) {
    error.name = title;
  }
  if (status !== undefined) {
    error.status = status;
  }

  return error;
}
